import { render, staticRenderFns } from "./BudgetCampaignLabel.vue?vue&type=template&id=30af26f1&"
import script from "./BudgetCampaignLabel.vue?vue&type=script&lang=ts&"
export * from "./BudgetCampaignLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports